import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE11Items = getItem('FE11', 'FE11', <FolderOutlined />, [
  getItem('Chapter 1 Unit Editor', 'FE11/Chapter1UnitEditor'),
  getItem('Chapter 10 Unit Editor', 'FE11/Chapter10UnitEditor'),
  getItem('Chapter 11 Unit Editor', 'FE11/Chapter11UnitEditor'),
  getItem('Chapter 12 Unit Editor', 'FE11/Chapter12UnitEditor'),
  getItem('Chapter 12x Unit Editor', 'FE11/Chapter12xUnitEditor'),
  getItem('Chapter 13 Unit Editor', 'FE11/Chapter13UnitEditor'),
  getItem('Chapter 14 Unit Editor', 'FE11/Chapter14UnitEditor'),
  getItem('Chapter 15 Unit Editor', 'FE11/Chapter15UnitEditor'),
  getItem('Chapter 16 Unit Editor', 'FE11/Chapter16UnitEditor'),
  getItem('Chapter 17 Unit Editor', 'FE11/Chapter17UnitEditor'),
  getItem('Chapter 17x Unit Editor', 'FE11/Chapter17xUnitEditor'),
  getItem('Chapter 18 Unit Editor', 'FE11/Chapter18UnitEditor'),
  getItem('Chapter 19 Unit Editor', 'FE11/Chapter19UnitEditor'),
  getItem('Chapter 2 Unit Editor', 'FE11/Chapter2UnitEditor'),
  getItem('Chapter 20 Unit Editor', 'FE11/Chapter20UnitEditor'),
  getItem('Chapter 20x Unit Editor', 'FE11/Chapter20xUnitEditor'),
  getItem('Chapter 21 Unit Editor', 'FE11/Chapter21UnitEditor'),
  getItem('Chapter 22 Unit Editor', 'FE11/Chapter22UnitEditor'),
  getItem('Chapter 23 Unit Editor', 'FE11/Chapter23UnitEditor'),
  getItem('Chapter 24 Unit Editor', 'FE11/Chapter24UnitEditor'),
  getItem('Chapter 24x Unit Editor', 'FE11/Chapter24xUnitEditor'),
  getItem('Chapter 25 Unit Editor', 'FE11/Chapter25UnitEditor'),
  getItem('Chapter 3 Unit Editor', 'FE11/Chapter3UnitEditor'),
  getItem('Chapter 4 Unit Editor', 'FE11/Chapter4UnitEditor'),
  getItem('Chapter 5 Unit Editor', 'FE11/Chapter5UnitEditor'),
  getItem('Chapter 6 Unit Editor', 'FE11/Chapter6UnitEditor'),
  getItem('Chapter 6x Unit Editor', 'FE11/Chapter6xUnitEditor'),
  getItem('Chapter 7 Unit Editor', 'FE11/Chapter7UnitEditor'),
  getItem('Chapter 8 Unit Editor', 'FE11/Chapter8UnitEditor'),
  getItem('Chapter 9 Unit Editor', 'FE11/Chapter9UnitEditor'),
  getItem('FEDS Character Editor (U)', 'FE11/FEDSCharacterEditorU'),
  getItem('FEDS Class Editor (U)', 'FE11/FEDSClassEditorU'),
  getItem('FEDS Class Editor (Update)', 'FE11/FEDSClassEditorUpdate'),
  getItem('FEDS Item Editor (U)', 'FE11/FEDSItemEditorU'),
  getItem('FEDS Item Editor (Update)', 'FE11/FEDSItemEditorUpdate'),
  getItem('Prologue 1 Unit Editor', 'FE11/Prologue1UnitEditor'),
  getItem('Prologue 2 Unit Editor', 'FE11/Prologue2UnitEditor'),
  getItem('Prologue 3 Unit Editor', 'FE11/Prologue3UnitEditor'),
  getItem('Prologue 4 Unit Editor', 'FE11/Prologue4UnitEditor'),
]);

export default FE11Items;
